export default "__VITE_ASSET__1b08486c__"